module.exports = __webpack_public_path__ + "static/img/dev_p5.8685afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developerCommunity/dev_p5.png
// module id = NmKL
// module chunks = 19